import * as React from 'react';
import { WrappedFieldProps } from 'redux-form';

import InputGroup from './InputGroup';

import styles from './Input.scss';

interface InputProps extends WrappedFieldProps {
  type?: React.InputHTMLAttributes<HTMLInputElement>['type'];
  placeholder?: React.InputHTMLAttributes<HTMLInputElement>['placeholder'];
  label?: string;
  disabled?: boolean;
  className?: string;
}

const Input: React.SFC<InputProps> = ({
  input,
  label,
  type,
  placeholder,
  meta,
  disabled,
  className,
}) => (
  <InputGroup label={label} meta={meta}>
    <input
      {...input}
      type={type}
      className={`${styles.input} ${className}`}
      placeholder={placeholder}
      disabled={disabled}
      maxLength={100}
    />
  </InputGroup>
);

export default (props: WrappedFieldProps) => <Input {...props} />;



// WEBPACK FOOTER //
// /www/client/src/components/Input/Input.tsx